<template>
<i class="el-icon-back" @click="goBack"></i>
</template>

<script>
export default {
  name: "goBack",
  methods: {
    goBack() {
      let prevRouterName = localStorage.getItem('goBackRouterName');
      if(prevRouterName){
        this.$router.push({name: prevRouterName});
      }else {
        this.$router.push({name: 'dashboard'});
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.el-icon-back {
  font-size: 20px;
  cursor: pointer;
  color: #5E5873;
  font-weight: bold;
}
</style>
